$(document).ready(function(){
    $(".details").on("click",function(){
        $(".accordion__content").toggle('open');
        $(".summary").toggleClass("rotate");
    });
});

/** Product Heading Equal Height **/

jQuery(function(){
    var heighest = 0;
    jQuery('.collection-matrix h4.titleChange, .collection-matrix a.product-thumbnail__title').each(function(){
        heighest = ($(this).height() > heighest) ? $(this).height() : heighest;
    });
    jQuery('.collection-matrix h4.titleChange, .collection-matrix a.product-thumbnail__title').css('height',heighest + 'px');
});